import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { reloadOnStaleChunk } from './utils/reload-on-stale-chunk';

import './styles/main.css';

reloadOnStaleChunk();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('#root not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
